var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('noti-page-header',{attrs:{"title":"User Guide"}}),_c('b-card',{attrs:{"no-body":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }